
(function () {
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  // reveal-on-scroll + clip targets + highlighter
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add("in");
      io.unobserve(e.target);
    });
  }, { threshold: 0.18 });
  document.querySelectorAll(".reveal, [data-clip], [data-hl]").forEach(function (el) { io.observe(el); });

  // Keep the mobile loyalty launcher from covering the trust panel.
  var trustStrip = document.querySelector(".trust-strip");
  if (trustStrip) {
    var trustIo = new IntersectionObserver(function (entries) {
      document.body.classList.toggle("trust-strip-visible", entries[0].isIntersecting);
    }, { threshold: 0.08 });
    trustIo.observe(trustStrip);
  }

  // stat counters
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var target = Number(e.target.dataset.count);
      if (reduced) { e.target.textContent = target; return; }
      var t0 = performance.now(), dur = 1400;
      (function tick(t) {
        var p = Math.min(((t || performance.now()) - t0) / dur, 1);
        e.target.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      })();
    });
  }, { threshold: 0.6 });
  document.querySelectorAll("[data-count]").forEach(function (el) { cio.observe(el); });

  // mobile drawer
  window.srDrawer = function (btn) {
    var d = document.getElementById("srdrawer");
    var open = d.hidden;
    d.hidden = !open;
    btn.setAttribute("aria-expanded", String(open));
    document.body.classList.toggle("drawer-open", open);
    if (!open) {
      // closing: reset panels
      d.querySelectorAll(".mpanel").forEach(function (p) { p.hidden = true; });
      d.querySelectorAll(".mcard[data-mpanel]").forEach(function (c) { c.setAttribute("aria-expanded", "false"); });
    }
  };
  // mobile menu accordion: a card with data-mpanel toggles its panel
  document.addEventListener("click", function (e) {
    var card = e.target.closest(".mcard[data-mpanel]");
    if (!card) return;
    var drawer = document.getElementById("srdrawer");
    if (!drawer) return;
    var key = card.getAttribute("data-mpanel");
    var panel = drawer.querySelector('.mpanel[data-panel="' + key + '"]');
    var isOpen = panel && !panel.hidden;
    drawer.querySelectorAll(".mpanel").forEach(function (p) { p.hidden = true; });
    drawer.querySelectorAll(".mcard[data-mpanel]").forEach(function (c) { c.setAttribute("aria-expanded", "false"); });
    if (panel && !isOpen) {
      panel.hidden = false;
      card.setAttribute("aria-expanded", "true");
      panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  });

  // hero carousel
  var car = document.querySelector("[data-f-carousel]");
  if (car) {
    var slides = car.querySelectorAll("[data-f-slide]");
    var dots = car.querySelectorAll("[data-f-dot]");
    var i = 0, timer = null;
    var show = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle("is-active", k === i);
        s.setAttribute("aria-hidden", String(k !== i));
      });
      dots.forEach(function (d, k) { var on = k === i; d.classList.toggle("is-active", on); d.setAttribute("aria-current", on ? "true" : "false"); });
    };
    dots.forEach(function (d, k) { d.addEventListener("click", function () { show(k); restart(); }); });
    var tick = function () { show(i + 1); };
    var restart = function () { if (timer) clearInterval(timer); if (!reduced && slides.length > 1) timer = setInterval(tick, 7000); };
    car.addEventListener("mouseenter", function () { if (timer) clearInterval(timer); });
    car.addEventListener("mouseleave", restart);
    // touch swipe (mobile)
    if (slides.length > 1) {
      var tx = 0, ty = 0, swiping = false;
      car.addEventListener("touchstart", function (e) {
        var t = e.changedTouches[0]; tx = t.clientX; ty = t.clientY; swiping = true;
        if (timer) clearInterval(timer);
      }, { passive: true });
      car.addEventListener("touchend", function (e) {
        if (!swiping) return; swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - tx, dy = t.clientY - ty;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { show(dx < 0 ? i + 1 : i - 1); }
        restart();
      }, { passive: true });
    }
    restart();
  }


  // ---- wishlist (localStorage) ----
  var WKEY = "sr_wishlist_v1";
  var wread = function () { try { return JSON.parse(localStorage.getItem(WKEY) || "[]"); } catch (e) { return []; } };
  var wwrite = function (a) { localStorage.setItem(WKEY, JSON.stringify(a)); wbadge(); };
  var wbadge = function () {
    var n = wread().length;
    document.querySelectorAll("[data-wish-count]").forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  };
  var wmark = function () {
    var saved = wread().map(function (i) { return i.handle; });
    document.querySelectorAll("[data-wish]").forEach(function (b) {
      b.classList.toggle("is-saved", saved.indexOf(b.dataset.handle) !== -1);
    });
  };
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-wish]");
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var list = wread();
    var idx = list.findIndex(function (i) { return i.handle === b.dataset.handle; });
    if (idx === -1) {
      list.push({ handle: b.dataset.handle, title: b.dataset.title, vendor: b.dataset.vendor, url: b.dataset.url, price: b.dataset.price, image: b.dataset.image });
    } else {
      list.splice(idx, 1);
    }
    wwrite(list); wmark(); wrender();
  });
  var wrender = function () {
    var grid = document.getElementById("wishlist-grid");
    if (!grid) return;
    var list = wread();
    var empty = document.querySelector("[data-wish-empty]");
    if (empty) empty.hidden = list.length > 0;
    grid.innerHTML = list.map(function (i) {
      return '<article class="card"><a class="card-media" href="' + i.url + '">' +
        '<button class="wish-btn is-saved" data-wish data-handle="' + i.handle + '" data-title="' + (i.title||'') + '" data-vendor="' + (i.vendor||'') + '" data-url="' + i.url + '" data-price="' + (i.price||'') + '" data-image="' + (i.image||'') + '" aria-label="Remove from wishlist"><svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7.5-4.6-10-9.3C.6 8.7 2 5.5 5 5.5c1.9 0 3.2 1.1 4 2.3.8-1.2 2.1-2.3 4-2.3 3 0 4.4 3.2 3 6.2C19.5 16.4 12 21 12 21Z"/></svg></button>' +
        (i.image ? '<img src="' + i.image + '" alt="' + (i.title||'') + '" loading="lazy" width="600" height="600">' : '') +
        '</a><div class="card-body"><p class="card-house">' + (i.vendor||'') + '</p><h3 class="card-name"><a href="' + i.url + '">' + (i.title||'') + '</a></h3><p class="card-price">' + (i.price||'') + '</p></div></article>';
    }).join("");
  };
  wbadge(); wmark(); wrender();

  // brand hub vendor search
  var input = document.getElementById("hubsearch");
  if (input) {
    var norm = function (s) { return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(); };
    var nores = document.getElementById("noresults");
    input.addEventListener("input", function () {
      var q = norm(input.value.trim());
      var any = false;
      document.querySelectorAll(".house").forEach(function (el) {
        var hit = !q || norm(el.textContent).indexOf(q) !== -1;
        el.hidden = !hit;
        if (hit) any = true;
      });
      document.querySelectorAll(".lgroup").forEach(function (g) {
        g.hidden = !Array.prototype.some.call(g.querySelectorAll(".house"), function (el) { return !el.hidden; });
      });
      if (nores) nores.hidden = any;
    });
  }
})();
